import { Topbar } from '@linearb/linui-common';
import { Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setAccount } from '../../../../RTK/account';
import { useLoadRootData } from '../../hooks/useLoadRootData';
import useTopbarDefaultProps from '../../hooks/useTopbarDefaultProps';
import {
  PlaygroundLayout,
  PlaygroundWrapper,
  SubTitle,
  Title,
  TitleComponent
} from './Playground.style';
import InputSection from './components/InputSection';
import ResultsSection from './components/ResultsSection';
import usePlaygroundData from './hooks/usePlaygroundData';
import { useGetDashboardData } from '../dashboard/hooks/useGetDashboardData';
import { LoginLoader } from '../../../login/components/LoginModal/LoginLoader';
import {
  OrgInfoWrapper,
  OrgName,
  SelectedOrgTitle
} from './components/Topbar/TopbarSection.style';

const Playground = () => {
  const { isLoading } = useGetDashboardData();

  useLoadRootData(false);

  const {
    gitstreamContext,
    gitstreamResults,
    gitstreamErrors,
    gitstreamAutomations,
    loading,
    ruleFileValidator,
    resetContext,
    executeGitstream,
    login
  } = usePlaygroundData();

  const dispatch = useDispatch();
  const topbarProps = useTopbarDefaultProps();

  const onLogoutClick = () => {
    dispatch(setAccount({}));
    topbarProps.onLogoutClick(false);
  };

  const selectedOrg = topbarProps.orgs.find(org => org.isSelected);

  const gitStreamDefaultProps = {
    Logo: (
      <TitleComponent>
        <Title data-cy='playground-title'>/:\ gitStream</Title>
        <SubTitle data-cy='playground-sub-title'>Playground</SubTitle>
        {selectedOrg && (
          <OrgInfoWrapper>
            <SelectedOrgTitle>Organization: </SelectedOrgTitle>
            <OrgName> {selectedOrg.name}</OrgName>
          </OrgInfoWrapper>
        )}
      </TitleComponent>
    ),
    onLogoutClick,
    showHelpCenter: false
  };

  const connectButtonProps = !topbarProps.loggedIn
    ? {
        ...gitStreamDefaultProps,
        container: (
          <Button onClick={login} variant='contained'>
            Login
          </Button>
        )
      }
    : gitStreamDefaultProps;

  return (
    <PlaygroundWrapper loggedIn={topbarProps.loggedIn}>
      <Topbar {...topbarProps} {...connectButtonProps} />

      {isLoading && <LoginLoader />}

      <PlaygroundLayout>
        <InputSection
          reset={resetContext}
          execute={executeGitstream}
          ruleFileValidator={ruleFileValidator}
          loading={loading}
          context={gitstreamContext}
        />
        <ResultsSection
          results={gitstreamResults}
          ruleFileErrors={ruleFileValidator.errors}
          gitstreamErrors={gitstreamErrors}
          gitstreamAutomations={gitstreamAutomations}
          loading={loading}
          context={gitstreamContext}
        />
      </PlaygroundLayout>
    </PlaygroundWrapper>
  );
};

export default Playground;
